let btns = document.querySelectorAll('.play-video');

// aspect ratio
let aspect = ( 16 / 9 );
// video margin
let margin = 20;
// min video width
let minWidth = 280;
// max video width
let maxWidth = 1200;

// fixed background element class
let containerClass = 'video-container';
// player container class
let playerClass = 'player';
// close button class
let closeClass = 'close icon icon-video-overlay-close';

// current video container
let current = null;

// youtube options
let opts = {
  origin: 'https://starry.com',
  modestbranding: 1,
  autoplay: 1,
  rel: 0,
  showinfo: 0,
  controls: 1,
  frameborder: 0
};

// bind handlers
btns.forEach( btn => {
  let url = btn.getAttribute('href');
  let color = btn.dataset.color || 'white';
  btn.addEventListener( 'click', ev => {
    ev.preventDefault();
    play( url, color );
  });
});

// create the player structure and bind close handlers
function createPlayer( url, color ) {
  let container = document.createElement('div');
  let player = document.createElement('div');
  let close = document.createElement('i');
  let iframe = document.createElement('iframe');

  container.className = containerClass + ' ' + color;
  player.className = playerClass;
  close.className = closeClass;

  url = buildURL( url );

  iframe.setAttribute( 'src', url );
  iframe.setAttribute( 'frameborder', '0' );

  player.appendChild( close );
  player.appendChild( iframe );
  container.appendChild( player );

  return container;
}

// add youtube query params to a base url
function buildURL( url ) {
  let params = Object.keys( opts ).map( key => `${ key }=${ opts[ key ] }` );

  return url + '?' + params.join('&');
}

// play a video
function play( url, color ) {
  let player = createPlayer( url, color );

  // remove any existing players
  kill();

  current = player;
  resize();

  player.addEventListener( 'click', kill, false );

  document.body.appendChild( player );
  // wait for next tick to add transition class
  setTimeout( () => {
    player.classList.add('is-open');
  }, 0 );

  window.addEventListener( 'keydown', onKeyDown );

}

// destroy the current video
function kill() {
  if ( !current ) {
    return;
  }

  let overlay = current.parentElement;
  current.classList.remove('is-open');
  current.addEventListener( 'transitionend', () => {
    overlay.removeChild( current );
    current = null;
  });
  window.removeEventListener( 'keydown', onKeyDown );
}

// deal with resize
function resize() {
  let position;
  let player;
  let iframe;

  if ( !current ) {
    return;
  }

  player = current.querySelector( '.' + playerClass );
  iframe = player.querySelector('iframe');

  position = getPosition();

  Object.keys( position ).forEach( function( key ) {
    player.style[ key ] = position[ key ] + 'px';
  });

  iframe.setAttribute( 'width', position.width );
  iframe.setAttribute( 'height', position.height );
}

// clamp to min/max value
function clamp( value, min, max ) {
  return Math.max( min, Math.min( value, max ) );
}

// determine optimal player position
function getPosition() {
  let viewWidth;
  let viewHeight;
  let width;
  let height;
  let top;
  let left;

  viewWidth = window.innerWidth;
  viewHeight = window.innerHeight;

  width = clamp( viewWidth - margin * 2, minWidth, maxWidth );
  height = width / aspect;

  // constrain height
  if ( height > ( viewHeight - margin * 2 ) ) {
    height = viewHeight - margin * 2;
    width = height * aspect;
  }

  top = ( viewHeight - height ) / 2;
  left = ( viewWidth - width ) / 2;

  return { width, height, top, left };
}

function onKeyDown( e ) {
  if ( !current ) {
    return;
  }
  if ( e.key === 'Escape' ) {
    kill();
  }
}

window.addEventListener( 'resize', resize, false );

export default undefined;
